/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FundUpdateRequestDto
 */
export interface FundUpdateRequestDto {
  /**
   *
   * @type {string}
   * @memberof FundUpdateRequestDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof FundUpdateRequestDto
   */
  fundGroupId: string;
}

export function FundUpdateRequestDtoFromJSON(json: any): FundUpdateRequestDto {
  return FundUpdateRequestDtoFromJSONTyped(json, false);
}

export function FundUpdateRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FundUpdateRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    name: json["name"],
    fundGroupId: json["fundGroupId"],
  };
}

export function FundUpdateRequestDtoToJSON(value?: FundUpdateRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    name: value.name,
    fundGroupId: value.fundGroupId,
  };
}
